import { getYaNative } from '@yanolja-rnd/ya-native'
import { isNative } from './typeguards'
import { useRouter } from 'next/router'
import * as sentry from '@sentry/browser'
import { useCallback } from 'react'
import qs from 'qs'

interface TransitionOptions {
  shallow?: boolean
  locale?: string | false
  scroll?: boolean
  unstable_skipClientCache?: boolean
}

type Options = {
  isReplace?: boolean
  routerPushOptions?: TransitionOptions
}
/**
 * 통합주문 도메인 내에서의 페이지 이동 util hook
 */
const useNavigateInternalUrl = () => {
  const router = useRouter()

  /**
   * 통합주문 도메인 내에서의 페이지 이동 util 함수.
   * - App: yaNative.wv
   * - Web: router.push
   * @param path 이동할 url path
   * @param isReplace router replace 여부 (useModalHash 에서 이동 시 사용)
   * @param routerPushOptions router push 옵션들
   */
  const navigateInternalUrl = useCallback((path: string, options?: Options) => {
    const yaNative = getYaNative()

    if (isNative(yaNative)) {
      const [urlPath, params] = path.split('?')
      yaNative.wv({
        method: 'get',
        url: `${window.location.origin}${urlPath}`,
        ...(params && { params: qs.parse(params, { depth: 0 }) as any }),
      })
    } else {
      if (options?.isReplace) {
        router.replace(path, undefined, options?.routerPushOptions).catch(sentry.captureException)
        return
      }
      router.push(path, undefined, options?.routerPushOptions).catch(sentry.captureException)
    }
  }, [])

  return { navigateInternalUrl }
}

export default useNavigateInternalUrl
